import React, { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import PlusSvg from "../../../../components/svg/PlusSvg";
import { InviteMemberModal } from "./InviteMemberModal";

/**
 * The purple "New User" button of Settings > Team (Members and Invitations). Opens the invite window;
 * `?invite=1` (old /settings/team/new-user address) opens it straight away. After sending, the
 * Invitations tab shows the new row.
 */
export const InviteButton: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("invite") === "1") {
      setOpen(true);
      params.delete("invite");
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [location.search, navigate]);

  return (
    <>
      <button
        type={"button"}
        onClick={() => setOpen(true)}
        className={
          "flex h-10 items-center justify-center gap-2 rounded-lg border border-[#6938EF] bg-[#6938EF] px-4 text-sm font-medium text-white"
        }>
        <PlusSvg />
        <span>New User</span>
      </button>
      {open && (
        <InviteMemberModal
          onClose={() => setOpen(false)}
          onSent={(name) => {
            setOpen(false);
            toast(
              `Invitation sent to ${name}. They'll get the email in a minute.`,
              {
                type: "success",
              },
            );
            navigate("/settings/team/invited-users");
          }}
        />
      )}
    </>
  );
};
